import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { useState } from 'react';

import Error from '@/components/common/Error';
import { DialogFooter } from '@/components/ui/dialog';
import { Form } from '@/components/ui/form';
import Input from '@/components/form/Input';
import SpinnerButton from '@/components/common/SpinnerButton';

import { useSelf, usePutSelf } from '@/data/user';

const formSchema = z.object({
  firstname: z.string().min(1, { message: 'Required' }),
  lastname: z.string().min(1, { message: 'Required' })
});

const ProfileForm = ({ setOpen }) => {
  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState('');
  const user = useSelf();
  const putSelf = usePutSelf();
  const form = useForm({
    resolver: zodResolver(formSchema),
    defaultValues: {
      firstname: user.data.firstname,
      lastname: user.data.lastname
    }
  });

  const onSubmit = async (values) => {
    setSubmitting(true);
    setApiError('');

    try {
      const response = await putSelf(values);
      await user.mutate(response, false);
      setSubmitting(false);
      setOpen(false);
    } catch (err) {
      setSubmitting(false);
      setApiError(err.message);
    }
  };

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-2 my-4">
        <div className="grid grid-cols-2 gap-2">
          <Input name="firstname" label="First Name" autoComplete="off" />
          <Input name="lastname" label="Last Name" autoComplete="off" />
        </div>

        {apiError && <Error error={apiError} />}
        <div className="pt-8">
          <DialogFooter>
            <SpinnerButton loading={submitting}>Save</SpinnerButton>
          </DialogFooter>
        </div>
      </form>
    </Form>
  );
};

export default ProfileForm;
